export enum TransactionsContext {
    ACCOUNT = 'ACCOUNT',
    CARD = 'CARD',
    FINANCING = 'FINANCING',
}
